import React, { useState, createRef, useEffect } from 'react'

import {
    Box,
    Button
} from '@mui/material';

import CommonBreadcumbs from '../../../../../components/common/CommonBreadcumbs';
import DataGridTable from '../../../../../components/common/DataGridTable';

import { useSystemPrompt } from '../../../../../hooks/useSystemPrompt';
import { useDataGridParams } from '../../../../../hooks/useDataGridParams';
import { useSystemRoutes, routeTypes } from '../../../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../../../hooks/useSystemHead';
import { useTranslations } from "../../../../../hooks/useTranslations";

import { markingInjectionProps, useMarking } from "../../../hooks/model/useMarking"

export default function ListMarkings({
    routeType
}) {

    const { t } = useTranslations({ ns: ["common", "@user", "_common"] })

    const { promptMessage } = useSystemPrompt();

    const { listMarkings } = useMarking({ routeType })

    const { defineColumns, columns, filterValues, getRenderColumnLink, getRenderColumnBooleanDisplay, getRenderColumnTextDisplay } = useDataGridParams('id')
    // const { isPermissionAllow } = usePermissions(routeType, scopeIds.user.id, scopeTypes.user.customer.id)

    const [selectedIds, setSelectedIds] = useState([])
    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const gridRef = createRef();

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try {

            const { data, count } = await listMarkings({ props })

            return {
                data,
                count
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }
    }

    // const filterValue =
    //     [
    //         { name: markingInjectionProps.marking.retrieveKey, operator: 'eq', type: 'string', value: '' },
    //         { name: 'company_name', operator: 'eq', type: 'string', value: '' },
    //         { name: 'branch_name', operator: 'eq', type: 'string', value: '' },
    //         { name: 'branch_contact', operator: 'eq', type: 'string', value: '' },
    //         { name: 'state_name', operator: 'eq', type: 'string', value: '' },
    //         { name: 'area_name', operator: 'eq', type: 'string', value: '' },
    //     ];

    useEffect(() => {

        defineColumnsView()

    }, [])

    const defineColumnsView = () => {
        defineColumns([
            {
                name: markingInjectionProps.marking.retrieveKey,
                header: t('marking'),
                renderValue: ({ value, cellProps }) => {

                    // if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) === false) {
                    //     return getRenderColumnTextDisplay(value)
                    // }

                    let path = getRoute(`users/customer/update/${cellProps.data.user_id}`);

                    return getRenderColumnLink(path, value)

                }
            },
            {
                name: 'company_name', header: t('company')
            },
            {
                name: 'branch_name', header: t('branchName')
            },
            {
                name: 'branch_contact', header: t('contact')
            },
            // {
            //     name: 'state_name', header: 'State'
            // },
            // {
            //     name: 'area_name', header: 'Area'
            // },

            {
                name: markingInjectionProps.sourceMarkingRemId.retrieveKey,
                header: 'SourceMarking'
            },
            {
                name: 'is_hq',
                header: t('hq'),
                renderValue: ({ cellProps, value }) => getRenderColumnBooleanDisplay(value, [t('mainHQ'), t('normal')], ["primary", "default"], "")
            },
        ])
    }

    const RenderDataGridTable = () => {

        return (
            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "user_id",
                    style: {
                        minHeight: 600
                    },
                    pageSizes: [20, 50, 100],
                    defaultLimit: 10,
                    defaultSkip: 0,
                    // checkboxColumn:
                    //     isPermissionAllow({ functionType: functionTypes.remove.id }),
                    columns,
                    defaultFilterValue: filterValues,
                    onSelectionChange: (items) => {
                        setSelectedIds(
                            items
                        )
                    }
                }}

            />
        )
    }

    return (
        <Box>

            {
                getHtmlHead({ routeType, title: t('customerMarkings') })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t('customerMarkings')}
                breadcrumbs={[
                    {
                        displayText: t('customers'),
                        props: {
                            href: getRoute('users/customers')
                        }
                    },
                    {
                        displayText: `${t('customerMarkings')}`,
                        props: {
                            color: 'secondary.main',
                        }
                    }
                ]}
            />

            {
                RenderDataGridTable()
            }
            {/*             
            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {
                            RenderDataGridTable()
                        }
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            } */}

        </Box>
    )
}
